import React from "react";
import { NavLink, withRouter } from "react-router-dom";

const ListGroup = ({
  items,
  textProperty,
  valueProperty,
  linkProperty,
  iconProperty,
  onItemSelect,
  location,
  history,
  variant = "body",
}) => {
  return (
    <ul
      className={
        variant === "body"
          ? "nav-section-body list-unstyled mb-0"
          : "list-unstyled mb-0"
      }
    >
      {items.map((item) => (
        <li key={item[valueProperty]}>
          <NavLink
            to={item[linkProperty]}
            onClick={(e) => {
              const targetPath = item[linkProperty];
              if (location?.pathname === targetPath && history?.replace) {
                e.preventDefault();
                history.replace({
                  pathname: targetPath,
                  state: {
                    ...(location?.state || {}),
                    refreshToken: Date.now(),
                  },
                });
              }
              if (onItemSelect) onItemSelect(item);
            }}
            className="nav-link-item nav-top-item text-decoration-none"
            activeClassName="active"
          >
            <span className="nav-link-icon">{item[iconProperty]}</span>
            <span className="nav-link-label">{item[textProperty]}</span>
          </NavLink>
        </li>
      ))}
    </ul>
  );
};

ListGroup.defaultProps = {
  textProperty: "name",
  valueProperty: "id",
  linkProperty: "to",
  iconProperty: "icon",
};

export default withRouter(ListGroup);
